import { MicrosoftXboxControllerBatteryUnknownIcon } from './MicrosoftXboxControllerBatteryUnknownIcon';

/**
 * author: Austin Andrews
 * id 9CC18C3C-57B6-470C-9F09-80B62ECFABD7
 * name microsoft-xbox-controller-battery-unknown
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-battery-unknown.svg
 * tags
 * - Battery 
 * - Gaming / RPG 
 */
export const MicrosoftXboxGamepadBatteryUnknownIcon = MicrosoftXboxControllerBatteryUnknownIcon;
export default MicrosoftXboxGamepadBatteryUnknownIcon